import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import {
  Button,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap';

import Loader from '~/components/Loader/Loader';
import { api2 } from '~/services/api';

import handleCommunityError from './communityError';
import { getCommunityTypeLabel } from './communityUtils';

export default function CommunityDetailsModal({
  communityId,
  raceCalendarName,
  open,
  toggle,
}) {
  const dispatch = useDispatch();
  const [community, setCommunity] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let mounted = true;

    async function loadCommunity() {
      setLoading(true);
      try {
        const response = await api2.get(`/communities/${communityId}`);
        if (mounted) setCommunity(response.data);
      } catch (error) {
        if (mounted) {
          handleCommunityError(
            error,
            dispatch,
            'Não foi possível carregar a comunidade.'
          );
          toggle();
        }
      } finally {
        if (mounted) setLoading(false);
      }
    }

    if (open && communityId) loadCommunity();

    return () => {
      mounted = false;
    };
  }, [communityId, dispatch, open, toggle]);

  return (
    <Modal isOpen={open} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>Detalhes da comunidade</ModalHeader>
      <ModalBody>
        {loading && <Loader />}
        {community && (
          <>
            {community.image && (
              <img
                className="community-details-image"
                src={community.image}
                alt={`Imagem da comunidade ${community.name}`}
              />
            )}
            <h4>{community.name}</h4>
            <p className="text-muted">{community.description}</p>

            <Row>
              <Col md={6}>
                <strong>Tipo</strong>
                <p>{getCommunityTypeLabel(community.type)}</p>
              </Col>
              <Col md={6}>
                <strong>Ordem</strong>
                <p>{community.order ?? 0}</p>
              </Col>
              <Col md={6}>
                <strong>Localização</strong>
                <p>
                  {community.city} - {community.state}
                </p>
              </Col>
              <Col md={6}>
                <strong>Corrida vinculada</strong>
                <p>
                  {community.race_calendar_id
                    ? raceCalendarName || 'Corrida não encontrada'
                    : 'Nenhuma'}
                </p>
              </Col>
              <Col md={6}>
                <strong>Criada em</strong>
                <p>
                  {community.created_at
                    ? moment(community.created_at).format('DD/MM/YYYY HH:mm')
                    : '-'}
                </p>
              </Col>
              <Col md={6}>
                <strong>Atualizada em</strong>
                <p>
                  {community.updated_at
                    ? moment(community.updated_at).format('DD/MM/YYYY HH:mm')
                    : '-'}
                </p>
              </Col>
              <Col md={6}>
                <strong>URL</strong>
                <p>
                  <a
                    href={community.url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Abrir comunidade
                  </a>
                </p>
              </Col>
            </Row>
          </>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Fechar
        </Button>
      </ModalFooter>
    </Modal>
  );
}
